import React, { useEffect } from "react";
import "./styles.css";
import GSlider from "../../components/HomePageComponents/Lib_Glider_Slider/GSlider";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import FeaturedProducts from "../../components/HomePageComponents/FeaturedProducts/FeaturedProducts";
import NewArrivals from "../../components/HomePageComponents/NewArrivals/NewArrivals";

const HomePage = ({
  countCartItems,
  cartItems,
  onAdd,
  onRemove,
  products,
  taxPrice,
  shippingPrice,
  totalPrice,
  itemsPrice,
}) => {
  useEffect(() => {
    setTimeout(() => {
      document.querySelector("#page_loader_wrapper").style.opacity = 0;
    }, 3000);
  }, []);

  const scrollToSection = (section_title) => {
    var ele = document.getElementById(section_title);
    window.scrollTo(ele.offsetLeft, ele.offsetTop);
  };
  return (
    <div>
      <header id="header" className="header">
        <Navbar
          countCartItems={countCartItems}
          cartItems={cartItems}
          onAdd={onAdd}
          onRemove={onRemove}
          products={products}
          taxPrice={taxPrice}
          shippingPrice={shippingPrice}
          totalPrice={totalPrice}
          itemsPrice={itemsPrice}
        />
        {/* <!-- Hero --> */}
        <div className="hero">
          <div className="hero__content container">
            <h1>
              <span>
                Get <span className="color">50%</span> off your first shopping
                with
              </span>
              <span>
                SHOPI<span className="color">Q</span> online shop
              </span>
            </h1>
            <span
              onClick={() => scrollToSection("new__arrival")}
              className="btn btn-hero"
            >
              shop now
            </span>
          </div>

          {/* <a href="#new__arrival" className="goto__next scroll-link"> */}
          <span
            onClick={() => scrollToSection("new__arrival")}
            className="goto__next scroll-link"
          >
            <span>
              <svg>
                <use xlinkHref="./images/sprite.svg#icon-angle-down"></use>
              </svg>
            </span>
          </span>
        </div>
      </header>
      ``
      {/* <!-- Main --> */}
      <main>
        {/* <!-- New Arrival --> */}
        <NewArrivals products={products} onAdd={onAdd} />
        <GSlider onAdd={onAdd} />

        {/* <!-- Special Offer Banner --> */}
        <section className="section special__offer">
          <div className="offer__container">
            <h1>SPECIAL OFFER</h1>
            <p>Special Offer Discount valid for Only this Week</p>
            <span onClick={() => scrollToSection("new__arrival")}>
              SHOP NOW
            </span>
          </div>
        </section>

        {/* <!-- Featured Section --> */}
        <FeaturedProducts />
        {/* <!-- Blog --> */}
        <section className="section blog" id="blog">
          <div className="blog__container container">
            <div className="title">
              <h1 className="primary__title">Latest News</h1>
            </div>

            <div className="blog__center">
              <div className="blog__box">
                <div className="img__cover">
                  <img src="./images/blog1.jpg" alt="" />
                </div>
                <div className="box__content">
                  <h2>Here are the trends I see coming this fall</h2>
                  <a href="/">Read more</a>
                </div>
              </div>

              <div className="blog__box">
                <div className="img__cover">
                  <img src="./images/blog2.jpg" alt="" />
                </div>
                <div className="box__content">
                  <h2>Here are the trends I see coming this fall</h2>
                  <a href="/">Read more</a>
                </div>
              </div>

              <div className="blog__box">
                <div className="img__cover">
                  <img src="./images/blog3.jpg" alt="" />
                </div>
                <div className="box__content">
                  <h2>Here are the trends I see coming this fall</h2>
                  <a href="/">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Newsletter --> */}
        <section className="section newsletter" id="newsletter">
          <div className="newsletter__container container">
            <div className="title">
              <h1 className="primary__title">Newsletter</h1>
            </div>

            <div className="newsletter__center">
              <div className="newsletter__box">
                <h2>Newsletter</h2>
                <p>
                  Subscribe to our newsletter and get 20% off your first
                  purchase
                </p>
              </div>

              <div className="newsletter__box">
                <form action="#">
                  <input type="email" placeholder="Your email" />
                  <button>SUBSCRIBE</button>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- Footer --> */}
        <Footer />
      </main>
    </div>
  );
};

export default HomePage;
